import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AuthService } from '../../core/security/auth.service';
import { Router } from '@angular/router';
import { MessagingGroupModel } from '../../api/models/messaging-group-model';
import { ContactLookupModel } from '../../api/models';
import { HeaderService } from '../../core/services/header.service';
import { MessagingService } from '../messaging.service';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatMiniFabAnchor, MatIconAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatBadge } from '@angular/material/badge';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { HumanizedDatePipe } from '../../core/pipes/humanized-date.pipe';
import { InitialsPipe } from '../../core/pipes/initials.pipe';
import { NameInitialsPipe } from '../../core/pipes/name-initials.pipe';

@Component({
    selector: 'app-phone-number-group-item',
    template: `
    <div class="item-container" *ngIf="!dataItem">
      <div class="item-avatar">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
      <div class="item-content">
        <div class="item-header">
          <h4 class="item-heading">Loading...</h4>
        </div>
      </div>
    </div>
    <div class="item-container" *ngIf="!!dataItem">
      <div class="item-avatar">
        <a mat-mini-fab class="mat-elevation-z0 unknown-user" *ngIf="!primaryContact?.name">
          <mat-icon>perm_identity</mat-icon>
        </a>
        <a mat-mini-fab class="mat-elevation-z0 unknown-user" *ngIf="primaryContact?.name">
          {{ primaryContact.name | initials }}
        </a>
      </div>
      <div class="item-content">
        <div class="item-header">
          <h4 class="item-heading">
            <span class="item-contact">
              {{ primaryContact?.name || primaryContact?.phoneNumber | phoneNumber }}

              <a
                mat-icon-button
                matTooltip="Add to contacts"
                *ngIf="hasContactsModule && hasContactsEditRight && primaryContact?.id === '0'"
                (click)="addNewContact($event, primaryContact)"
              >
                <mat-icon fontSet="material-icons-outlined">person_add</mat-icon>
              </a>
            </span>
            <span class="item-phone">{{ primaryContact?.phoneNumber | phoneNumber }}</span>
          </h4>
          <div class="right-holder">
            <time class="item-time">
              {{ dataItem.lastTime | humanizedDate }}
            </time>
            <div
              class="item-badge"
              *ngIf="dataItem.unread > 0"
              [matBadge]="dataItem.unread"
              matBadgePosition="before"
              matBadgeColor="warn"
            ></div>
          </div>
        </div>
        <div class="item-last-message">
          <p [innerHTML]="dataItem.lastMessage || 'This message was deleted'"></p>
        </div>
      </div>
    </div>
  `,
    styleUrls: ['./phone-number-group-item.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MatProgressSpinner,
        MatMiniFabAnchor,
        MatIcon,
        MatIconAnchor,
        MatTooltip,
        MatBadge,
        PhoneNumberPipe,
        HumanizedDatePipe,
        InitialsPipe,
        NameInitialsPipe,
    ],
})
export class PhoneNumberGroupItemComponent implements OnChanges {
  @Input() dataItem: MessagingGroupModel;
  @Input() wabaConvExp: string;
  @Input() searchText: string;
  @Input() hasContactsModule = false;
  @Input() hasContactsEditRight = false;

  primaryContact: ContactLookupModel = {};

  constructor(
    public authService: AuthService,
    public headerService: HeaderService,
    public messagingService: MessagingService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.dataItem && this.dataItem.contacts && this.dataItem.contacts.length > 0) {
      this.primaryContact = this.dataItem.contacts[0];
    }
  }

  addNewContact($event: MouseEvent, primaryContact: ContactLookupModel) {
    $event.preventDefault();
    this.router.navigate([this.headerService.themePrefix, 'contacts', 'contact', 'new', 'edit'], {
      queryParams: { phoneNumber: primaryContact?.phoneNumber },
    });
  }
}
